import { app, nativeWindow } from '@todesktop/client-core';

export async function revealDesktopAppWindow(): Promise<void> {
  if (await nativeWindow.isMinimized()) {
    await nativeWindow.restore();
  }

  // Closing Cubic into the tray hides its window, so activating the app alone does not reveal it.
  await nativeWindow.show();
  await app.focus({ steal: true });
}
